import { motion } from "framer-motion";
import { Award, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import ChapterHeading from "@/components/ChapterHeading";
import { RECONOCIMIENTOS } from "@/data/content";

const EASE = [0.16, 1, 0.3, 1];

export default function Reconocimientos({ config }) {
  const openLink = (r) => {
    const url = config?.award_links?.[r.id];
    if (url && url !== "#") {
      window.open(url, "_blank", "noopener,noreferrer");
    } else {
      toast.info("La nota oficial estará disponible próximamente", {
        description: r.nombre,
      });
    }
  };

  return (
    <section id="reconocimientos" data-testid="reconocimientos-section" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <ChapterHeading
          num="02 · Reconocimientos"
          title="Premios y certificaciones que respaldan la gestión"
          desc="Distinciones nacionales e internacionales recibidas por el Ayuntamiento de Tampico durante el periodo 2024—2027."
        />
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {RECONOCIMIENTOS.map((r, i) => (
            <motion.article
              key={r.id}
              data-testid={`reconocimiento-card-${r.id}`}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-30px" }}
              transition={{ duration: 0.6, delay: (i % 4) * 0.08, ease: EASE }}
              className="group flex flex-col bg-arena-light/60 hover:bg-arena-light rounded-2xl border border-border hover:border-guinda/40 p-6 transition-colors duration-300"
            >
              <div className="flex items-start justify-between gap-3">
                <span className="p-2.5 rounded-xl bg-guinda/10 text-guinda">
                  <Award className="w-5 h-5" aria-hidden="true" />
                </span>
                <span className="font-mono text-xs text-gris bg-white border border-border rounded-full px-2.5 py-1">
                  {r.anio}
                </span>
              </div>
              <h3 className="mt-4 font-serif font-semibold text-lg text-gris-charcoal leading-snug">{r.nombre}</h3>
              <p className="mt-1 text-xs font-mono uppercase tracking-widest text-guinda">{r.emisor}</p>
              <p className="mt-3 text-sm text-gris leading-relaxed flex-1">{r.detalle}</p>
              <button
                type="button"
                data-testid={`reconocimiento-link-${r.id}`}
                onClick={() => openLink(r)}
                className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-guinda hover:text-guinda-dark transition-colors duration-200"
              >
                Ver nota oficial
                <ExternalLink className="w-3.5 h-3.5" aria-hidden="true" />
              </button>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
